import { fromJS } from 'immutable';
import { SET_GAMES, DELETE_GAMES, CREATE_GAME_SUCCESS, CREATE_GAME } from './constants';
import { APP_RESET } from '../App/constants';

const initialState = fromJS({
  games: [],
  // Whether the list has come back from the server yet: until it has, no games doesn't mean there are none.
  loaded: false,
  creating: false,
});

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_GAMES:
      return state.set('games', action.payload.get('games')).set('loaded', true);

    case CREATE_GAME:
      return state.set('creating', true);

    case CREATE_GAME_SUCCESS:
      return state.set('creating', false);

    // Gone from the list right away; if the server refuses, the list loads again (Games/sagas).
    case DELETE_GAMES:
      return state.set('games', state.get('games').filterNot(
        (game) => action.payload.get('gameIds').includes(game.get('id'))
      ));

    case APP_RESET:
      return initialState;

    default:
      return state;
  }
}

export default reducer;
